import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { msToStringFormatted } from "./time";

	
const StyledText = ({ text }) => {
	// Convert **bold** text
	const boldText = text?.replace(/\*\*(.*?)\*\*/g, '<span class="font-bold">$1</span>');

	// Convert *italic* text
	const italicText = boldText.replace(/\*(.*?)\*/g, '<span class="italic">$1</span>');

	// Convert _underline_ text
	const underlineText = italicText.replace(/_(.*?)_/g, '<span class="underline">$1</span>');

	// Convert *strikethrough* text
	const strikethrough = underlineText.replace(/~(.*?)~/g, '<span class="line-through">$1</span>');
	
	// Convert *strikethrough* text
	const newLine = strikethrough.replace(/\\n/g, '<br />');

	// Render the HTML using dangerouslySetInnerHTML
	return <span className="py-0" dangerouslySetInnerHTML={{ __html: newLine }} />;
	// return <ReplaceWithDataSource text={finalText} />
}

export const ReplaceWithDataSource = ({ text = "", keepBrakets = false, styled = false }) => {
	const { projectId } = useParams();
	const selectedProject = useSelector(
		(state) => state.main?.projects?.[projectId]
	);
	const cues = selectedProject?.cues;

	const dynamicText = useSelector(
		(state) => state.main?.projects?.[projectId]?.dynamicText
	);
	const dynamicLists = useSelector(
		(state) => state.main?.projects?.[projectId]?.dynamicLists
	);
	const returnedString = replaceWithDataSource(
		text,
		dynamicText,
		dynamicLists,
		keepBrakets,
		cues
	);
	if (styled) {
		return <StyledText text={returnedString}/>
	} else {
		return returnedString
	}
};

export const replaceWithDataSource = (
	text = "",
	dynamicText,
	dynamicLists,
	keepBrakets = false,
	cues = []
) => {
	const array = text.split(/\[(.*?)\]/g);
	let array2;
	const regEx = /\[(.*?)\]/g;
	const regexForGraphicData = /\[[A-Z0-9]{5}\.(.*?)\]/g;
	const match = text.match(regEx);
	const matchForGraphic = text.match(regexForGraphicData);

	if (!match) return text;

	array2 = [...array];

	if (matchForGraphic) {
		const regex = /(\w+)\.(\w+)/;
		const match = regex.exec(text);
		const matchingVariable = cues?.filter((c) => c.id === match?.[1])?.[0];
		let returnText = matchingVariable?.[match?.[2]];

		// social specific
		if (matchingVariable?.type === "social") {
			switch (match?.[2]) {
				case "current_comment":
					returnText = matchingVariable?.chat?.snippet?.displayMessage;
					break;

				case "current_author":
					returnText = matchingVariable?.chat?.authorDetails?.displayName;
					break;

				default:
					break;
			}
		}
		// video specific
		if (matchingVariable?.type === "video") {
			switch (match?.[2]) {
				case "time_remaining":
					returnText = msToStringFormatted(
						(parseInt(matchingVariable?.length) -
							parseInt(matchingVariable?.currentTime)) *
							1000,
						false,
						"HH:mm:ss"
					);
					break;

				case "time_elapsed":
					returnText = msToStringFormatted(
						parseInt(matchingVariable?.currentTime) * 1000,
						false,
						"HH:mm:ss"
					);
					break;

				default:
					break;
			}
		}

		return !keepBrakets ? returnText || "" : `[${returnText || "Not set"}]`;
	}

	match.forEach((m, i) => {
		let m2 = m.replace("[", "");
		let m3 = m2.replace("]", "");
		let pullFromList = false;
		let list = 0;
		let row = 1;
		let cell = 0;

		const index = array.indexOf(m3);

		if (m3.includes("row") && m3.includes("cell")) {
			pullFromList = true;
			let split = m3.split(".");
			list = split[0]?.replace("list", "");
			row = split[1]?.replace("row", "");
			cell = split[2]?.replace("cell", "");
		}

		let returnString = pullFromList
			? dynamicLists?.[parseInt(list) - 1]?.[parseInt(row)]?.[
					parseInt(cell) - 1
			  ]?.value
			: dynamicText?.[m3];

		array2.splice(index, 1);
		array2.splice(
			index,
			0,
			!keepBrakets ? returnString : `[${returnString || "Not set"}]`
		);
	});
	return array2.join("")
};

export const containsDataSourceList = (text = "") => {
	const regEx = /\[(list.*?)\]/g;
	const match = text.match(regEx);

	if (match) return match[0];

	return false;
};

export const extractNumberFromList = (inputString) => {
	const regex = /\[list(\d+)\.\d+\]/;
	const match = regex.exec(inputString);
	if (match && match.length > 1) {
			return parseInt(match[1] - 1); // The number captured by the first capturing group
	} else {
			return null; // No match found
	}
}
